var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.isEmptyData
    ? _c("v-client-table", {
        staticClass: "w-100 vue-custom-table no-pagination text-center",
        attrs: {
          data: _vm.submissions,
          columns: _vm.tableColumns,
          options: _vm.options,
          name: "submissionHistoryTable",
        },
        scopedSlots: _vm._u(
          [
            {
              key: "date",
              fn: function (ref) {
                var row = ref.row
                return [
                  _c("div", { staticClass: "column" }, [
                    _c("p", { staticClass: "mb-0" }, [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm._f("formatDate")(row.createdAt)) +
                          "\n      "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "mb-0 small" }, [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm._f("formatDateTimezone")(row.createdAt)) +
                          "\n      "
                      ),
                    ]),
                  ]),
                ]
              },
            },
            {
              key: "type",
              fn: function (ref) {
                var row = ref.row
                return [
                  _c("p", { staticClass: "mb-0 capitalize" }, [
                    _vm._v("\n      " + _vm._s(row.dealType) + "\n    "),
                  ]),
                ]
              },
            },
            {
              key: "lender",
              fn: function (ref) {
                var row = ref.row
                return [
                  _c(
                    "p",
                    {
                      directives: [
                        {
                          name: "b-tooltip",
                          rawName: "v-b-tooltip.top.html",
                          value: _vm.$t(
                            "application-form." + row.submissionMethod
                          ),
                          expression:
                            "$t('application-form.' + row.submissionMethod)",
                          modifiers: { top: true, html: true },
                        },
                      ],
                      staticClass: "mb-0 capitalize",
                    },
                    [_vm._v("\n      " + _vm._s(row.lenderName) + "\n    ")]
                  ),
                ]
              },
            },
            {
              key: "status",
              fn: function (ref) {
                var row = ref.row
                return [
                  _vm.parseErrors(row).length
                    ? _c("notification-popover", {
                        attrs: {
                          title: _vm.$t(
                            "direct-to-lender.lenderSubmit.failedReason"
                          ),
                          triggers: "hover",
                          type: "error",
                          placement: "top",
                          boundary: "viewport",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "popoverTarget",
                              fn: function () {
                                return [
                                  _c("submission-status-badge", {
                                    attrs: { status: row.status },
                                  }),
                                ]
                              },
                              proxy: true,
                            },
                            {
                              key: "popoverContent",
                              fn: function () {
                                return [
                                  _c("div", { staticClass: "p-2" }, [
                                    _c(
                                      "ul",
                                      { staticClass: "bullet px-3" },
                                      _vm._l(
                                        _vm.parseErrors(row),
                                        function (err, index) {
                                          return _c("li", { key: index }, [
                                            _c("h6", [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(err) +
                                                  "\n              "
                                              ),
                                            ]),
                                          ])
                                        }
                                      ),
                                      0
                                    ),
                                  ]),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          true
                        ),
                      })
                    : _c("submission-status-badge", {
                        directives: [
                          {
                            name: "b-tooltip",
                            rawName: "v-b-tooltip",
                            value: {
                              title: _vm.$t(
                                "application.messages.processingApplicationStatus"
                              ),
                              disabled: !_vm.shouldShowProcessingTooltip(row),
                            },
                            expression:
                              "{\n        title: $t('application.messages.processingApplicationStatus'),\n        disabled: !shouldShowProcessingTooltip(row)\n      }",
                          },
                        ],
                        attrs: { status: row.status },
                      }),
                ]
              },
            },
            {
              key: "insurance",
              fn: function (ref) {
                var row = ref.row
                return [
                  _c("p", { staticClass: "mb-0 capitalize" }, [
                    _vm._v(
                      "\n      " +
                        _vm._s(
                          _vm._f("formatMoneyValue")(row.miPremiumAmount)
                        ) +
                        "\n    "
                    ),
                  ]),
                ]
              },
            },
            {
              key: "mortgage",
              fn: function (ref) {
                var row = ref.row
                return [
                  _c("p", { staticClass: "mb-0 capitalize" }, [
                    _vm._v("\n      " + _vm._s(row.mortgageType) + "\n    "),
                  ]),
                ]
              },
            },
            {
              key: "loanAmount",
              fn: function (ref) {
                var row = ref.row
                return [
                  _c("p", { staticClass: "mb-0 capitalize" }, [
                    _vm._v(
                      "\n      " +
                        _vm._s(
                          _vm._f("formatMoneyValue")(row.totalLoanAmount)
                        ) +
                        "\n    "
                    ),
                  ]),
                ]
              },
            },
            {
              key: "actions",
              fn: function (ref) {
                var row = ref.row
                return [
                  _c("div", [
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-none d-xl-flex flex-row justify-content-end",
                      },
                      [
                        _c(
                          "b-dropdown",
                          {
                            attrs: {
                              text: "Actions",
                              "toggle-class": "btn btn-white btn-sm",
                              variant: "white",
                              boundary: "viewport",
                              dropup: "",
                              right: "",
                            },
                          },
                          [
                            _c(
                              "b-dropdown-item",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.applicationPdf(row)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.$tc("global.doorr.application", 1)
                                    ) +
                                    "\n          "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-dropdown-item",
                              {
                                directives: [
                                  {
                                    name: "b-tooltip",
                                    rawName: "v-b-tooltip.left",
                                    value: {
                                      title: _vm.$t(
                                        "direct-to-lender.messages.noLenderNote"
                                      ),
                                      disabled: row.lenderNote,
                                      boundary: "viewport",
                                    },
                                    expression:
                                      "{\n              title: $t('direct-to-lender.messages.noLenderNote'),\n              disabled: row.lenderNote,\n              boundary: 'viewport'\n            }",
                                    modifiers: { left: true },
                                  },
                                ],
                                attrs: { disabled: !row.lenderNote },
                                on: {
                                  click: function ($event) {
                                    return _vm.lenderNote(row)
                                  },
                                },
                              },
                              [
                                _c("span", [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.$t(
                                          "direct-to-lender.lenderSubmit.lenderNote"
                                        )
                                      ) +
                                      "\n            "
                                  ),
                                ]),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex flex-row justify-content-end d-xl-none",
                      },
                      [
                        _c(
                          "b-dropdown",
                          {
                            attrs: {
                              variant: "link",
                              "toggle-class": "text-black position-static",
                              "toggle-tag": "span",
                              boundary: "scrollParent",
                              right: "",
                              dropup: "",
                              "no-caret": "",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "button-content",
                                  fn: function () {
                                    return [
                                      _c(
                                        "i",
                                        { staticClass: "material-icons" },
                                        [_vm._v("more_vert")]
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          [
                            _vm._v(" "),
                            _c("b-dropdown-header", [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("global.words.actions")) +
                                  "\n          "
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "b-dropdown-item",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.applicationPdf(row)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.$tc("global.doorr.application", 1)
                                    ) +
                                    "\n          "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-dropdown-item",
                              {
                                attrs: { disabled: !row.lenderNote },
                                on: {
                                  click: function ($event) {
                                    return _vm.lenderNote(row)
                                  },
                                },
                              },
                              [
                                _c("span", [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.$t(
                                          "direct-to-lender.lenderSubmit.lenderNote"
                                        )
                                      ) +
                                      "\n            "
                                  ),
                                ]),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                ]
              },
            },
          ],
          null,
          false,
          2575506885
        ),
      })
    : _c(
        "div",
        { staticClass: "d-flex flex-column align-items-center w-100" },
        [
          _c(
            "no-results",
            {
              attrs: {
                "img-src": require("@Shared/@Assets/img/application-missing.png"),
              },
            },
            [
              _vm._v(
                "\n    " +
                  _vm._s(
                    _vm.$t("direct-to-lender.lenderSubmit.emptySubmissions")
                  ) +
                  "\n  "
              ),
            ]
          ),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }